import axios from "api/axios"
import { APIResponse, Config, NoContentType } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { LeadProfile, LeadQualification } from "./types"
import { urls } from "./urls"

export default {
  getLeadData: async ({ data }: Config): Promise<APIResponse<LeadProfile>> => {
    try {
      const res = await axios.post(urls.lead.getData(), {
        suraasa_lead_id: data.suraasaLeadId,
      })
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  saveData: async ({
    data,
    params,
  }: Config): Promise<APIResponse<NoContentType>> => {
    try {
      const res = await axios.put(
        urls.lead.saveData(params.userPrimaryKey),
        data
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  addQualification: async ({
    data,
    params,
  }: Config): Promise<APIResponse<LeadQualification>> => {
    try {
      const res = await axios.post(
        urls.lead.addQualification(params.suraasaLeadId),
        data
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  updateQualification: async ({
    data,
    params,
  }: Config): Promise<APIResponse<LeadQualification>> => {
    try {
      const res = await axios.put(
        urls.lead.updateQualification(params.qualificationId),
        data
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  deleteQualification: async ({
    params,
  }: Config): Promise<APIResponse<NoContentType>> => {
    try {
      const res = await axios.delete(
        urls.lead.deleteQualification(params.qualificationId)
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
}
